<template>
    <el-container>
        <el-header>
            <div class="logocss">
                <img src="../../assets/yb1.jpg" alt="" class="logo_yb">
                <div style="font-weight: 700;font-size:16px;">翼博餐饮管理系统</div>
            </div>
            <div class="info">
                <div class="select-menu">
                    <el-dropdown>
                        <span class="el-dropdown-link">
                        欢迎您,xxx
                        </span>
                        <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item icon="el-icon-setting" divided @click.native="edit">密码修改</el-dropdown-item>
                        <el-dropdown-item icon="el-icon-remove" divided @click.native="exit">退出登录</el-dropdown-item>
                        <el-dropdown-item icon="el-icon-sort" divided @click.native="selectPro">切换项目</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="content-title-time">
                当前时间:{{ currenTime }}
                </div>
            </div>
        </el-header>
        <el-container>
            <el-aside width="200px">
              
                <!-- :collapse="isCollapse" -->
                <el-menu
                :collapse-transition="false"
                class="el-menu-vertical-demo"
                :default-active="$route.path"
                background-color="#ffffff"
                text-color="#000000"
                unique-opened
                router
                active-text-color="#ffffff">
                    <!-- <el-submenu index="/article">
                        <template slot="title">
                        <i class="el-icon-tickets"></i>
                        <span slot="title">文章管理</span>
                        </template>
                        <el-menu-item-group>
                        <el-menu-item index="/article">选项1</el-menu-item>
                        <el-menu-item index="/test">选项2</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu> -->
                    <el-menu-item index="/article">
                        <i class="el-icon-tickets"></i>
                        <span slot="title">文章管理</span>
                    </el-menu-item>
                </el-menu>
            </el-aside>
            <el-main>
                <router-view/>
            </el-main>
        </el-container>
    </el-container>
</template>
5
<script>
export default {
    data() {
      return {
        currenTime:'',
      };
    },
    created(){
        // 获取头部当前时间
        setInterval(this.updateClock, 1000);
        // 初始化调用一次 updateTime 方法
        this.updateClock();
    },
    methods: {
       // 头部获取当前时间的方法
    // 创建一个函数来更新时间
    updateClock() {
        // 获取当前时间
        var now = new Date();

        // 获取年、月、日、时、分和秒
        var year = now.getFullYear();
        var month = now.getMonth() + 1; // 月份从 0 开始，因此要加 1
        var day = now.getDate();
        var hours = now.getHours();
        var minutes = now.getMinutes();
        var seconds = now.getSeconds();

        // 将时间显示为两位数
        month = month < 10 ? '0' + month : month;
        day = day < 10 ? '0' + day : day;
        hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;

        // 更新时间显示
        this.currenTime =  year + '年' + month + '月' + day + '日' + hours + ':' + minutes + ':' + seconds;
        },
    }
  }
</script>

<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
    /* width: 200px; */
    min-height: 400px;
  }
.el-container{
    height: 100vh;
    width: 100vw;
}
.el-header, .el-footer {
    background-color: #1890ff;
    color: #fff;
    text-align: center;
    line-height: 60px;
    padding: 0 !important;
    display: flex;
  }
  
  .el-aside {
    background-color: #fff;
    color: #333;
    position: relative;
  }
  
  .el-main {
    background-color: #f0f2f5;
  color: #333;
  /* 取消el-main的默认padding值 */
  padding: 0px 5px !important;
  }
  .el-menu{
    border-right:none ;
    }
  body > .el-container {
    margin-bottom: 40px;
  }
  
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }
  
  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
  /* 修改选中菜单样式 */
.el-menu-item.is-active{
  background-color: #e6f7ff !important;
  color: #1890ff !important;
}
/* 菜单导航 */
::v-deep .el-scrollbar__bar.is-vertical{
  width: 0 !important;
}
/* logo CSS */
.logocss{
    width: 200px;
    height: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    /* background-color: pink; */
}
.logo_yb{
    width: 40px;
    height: 40px;
}
/* 个人信息和时间 */
.info{
    width: calc(100vw - 200px);
    height: 100%;
    font-size: 16px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    color: white;
}
.el-dropdown-link{
    color: white;
}
.select-menu{
    margin-right: 30px;
    color: white;
}
.content-title-time{
    margin-right: 20px;
}
</style>